"use strict";

 angular.module('config', [])

.constant('$globalConfiguration', {
    name: 'distribution',
    apiEndpoint: '',
    apiOAuthAuthorizePath: '/issue/oauth2/authorize',
    apiOAuthSignOutPath: '/issue/oauth2/signout',
    apiOAuthClientID: 'accountsmatrix42com',
    apiOAuthScope: 'urn:matrix42com',
    deploymentUUID: '7cc5b652-4dd8-48ff-9579-23820b56e717',
    redirectSavedUrls: ['lang']
})

;